export default "__VITE_ASSET__8002957c__"